<template>
  <div>
    <div class="container">
      <div class="wh1200">
        <div class="flex">
          <img src="@/assets/images/ldgx-logo.png" @click="$router.push('/')" alt=""
            style="cursor: pointer; width: 374px; height: 45px; color: #001528" />
        </div>
        <div class="flex"></div>
      </div>
      <span class="someTips">独立 公正 专业 高效</span>
      <div class="loginBox">
        <div id="scanCode" @click="clickCode">
          <img src="@/assets/images/exampleEwm.png" style="cursor: pointer" />
        </div>
        <div id="qrcodeContainer" v-if="qrcodeType.show">
          <div class="qrcodeBtnTop" @click="hideEvent">
            使用账号登录 <i class="el-icon-right"></i>
          </div>
          <div id="qrcode">
            <div v-loading="loading">
              <img :src="base64" style="width: 200px; height: 200px" alt="" v-if="flag == 0" />
              <img src="@/assets/images/success.png" v-else-if="flag == 1" />
              <img src="@/assets/images/fail.png" v-else-if="flag == 2" />
            </div>
            <!-- <img src="@/assets/images/fail.png"> -->
            <!-- <p >dakjdawkdjawdkjhajkdakwhgdkawdkawghdkjawgdkwagdkgjwadawkjgdawkjdgjka</p> -->
            <p style="width: 300px; word-wrap: break-word; text-align: center">
              {{ this.msg }}
            </p>
          </div>
          <!-- <div class="qrcodeBtn" style="cursor:pointer;" @click="hideEvent">刷新</div> -->
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane label="密码登录" name="first">
            <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-position="left"
              label-width="0px" @submit.native.prevent>
              <el-form-item prop="userType">
                <!-- <el-radio
                  v-model="passwordForm.userType"
                  label="0"
                  v-removeAriaHidden
                  >个人</el-radio
                >
                <el-radio
                  v-model="passwordForm.userType"
                  label="1"
                  v-removeAriaHidden
                  >企业</el-radio
                > -->
              </el-form-item>
              <el-form-item prop="userName">
                <el-input v-model="passwordForm.userName" prefix-icon="el-icon-user"
                  placeholder="请输入居民身份证号/手机号"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="passwordForm.password" type="password" prefix-icon="el-icon-lock"
                  placeholder="请输入密码"></el-input>
              </el-form-item>
              <!--            <el-form-item prop="code" >-->
              <!--              <el-input v-model="form.code" prefix-icon="el-icon-message" placeholder="请输入验证码">-->
              <!--                <el-button  slot="append" @click="getTeleohoneCode(2)" :disabled="isCanGetCode2">{{btnText2}}</el-button>-->
              <!--              </el-input>-->
              <!--              <span  v-if="showTips2" style="display: flex;justify-content: flex-end;color: #909399;font-size: 12px">验证码有效时间为5分钟！</span>-->

              <!--            </el-form-item>-->

              <el-form-item>
                <el-button type="primary" style="width: 100%" :disabled="isCanLogin" @click="login(1)">登录</el-button>
              </el-form-item>
            </el-form>
            <div class="otherDo">
              <el-link type="primary" :underline="false" @click="goPage('register')">新用户注册</el-link>
              <img src="@/assets/images/loginHome/vx.png" alt="" width="30px" @click="clickCode"
                style="cursor: pointer" />
              <el-link type="primary" :underline="false" @click="goPage('forget')">忘记密码？</el-link>
            </div>
            <!-- <div style="text-align: center; font-size: 12px; margin-top: 10px;">其他登录方式</div> -->

            <el-divider>其他登录方式</el-divider>
            <div class="imgss" @click="initQrCode">
              <img src="@/assets/images/电子社保卡.png" alt="" class="sbks">
              <div style="font-size:12px">电子社保卡登录</div>

            </div>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="second">
            <el-form ref="form" :model="form" :rules="rules" label-width="0px">
              <el-form-item prop="userType">
                <!-- <el-radio v-model="form.userType" label="0">个人</el-radio>
                <el-radio v-model="form.userType" label="1">企业</el-radio> -->
              </el-form-item>
              <!--            <el-form-item prop="idCard">-->
              <!--              <el-input v-model="form.idCard" prefix-icon="el-icon-bank-card" placeholder="请输入居民身份证号"></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item prop="telephone">
                <el-input v-model="form.telephone" prefix-icon="el-icon-phone-outline" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="form.code" prefix-icon="el-icon-message" placeholder="请输入验证码">
                  <el-button slot="append" @click="getTeleohoneCode" :disabled="isCanGetCode2">{{ btnText2
                  }}</el-button>
                </el-input>
                <span v-if="showTips2" style="
                    display: flex;
                    justify-content: flex-end;
                    color: #909399;
                    font-size: 12px;
                  ">验证码有效时间为5分钟！</span>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" style="width: 100%" :disabled="isCanLogin" @click="login(2)">登录</el-button>
              </el-form-item>
            </el-form>
            <div class="otherDo">
              <el-link type="primary" :underline="false" @click="goPage('register')">新用户注册</el-link>
              <img src="@/assets/images/loginHome/vx.png" alt="" width="30px" @click="clickCode"
                style="cursor: pointer" />
              <el-link type="primary" :underline="false" @click="goPage('forget')">忘记密码？</el-link>
            </div>
            <el-divider>其他登录方式</el-divider>
            <div class="imgss" @click="initQrCode">
              <img src="@/assets/images/电子社保卡.png" alt="" class="sbks">
              <div style="font-size:12px">电子社保卡登录</div>

            </div>

          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
    <div class="bottom_bg">
      <Footer />
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import Footer from "@/common/footer/footer.vue";
import { isCardID } from "@/utils/validate";

import {
  getUuid,
  loginIn,
  getPhoneCode,
  switchingBinding,
  existenceOrNot,
  wechatLoginLog,
  getsbklogin,
  sbktoken,
  sbklogins
} from "@/api/login.js";
import { forgetThePassword } from "@/api/userFile";
import { f } from "core-js/internals/new-promise-capability";
export default {
  name: "login",
  inject: ["showEwm"],
  components: { Footer },
  data() {
    return {
      //获取浏览器的地址
      backUrl: "",
      ldGx005a:"",
      // 0 等待中 1 成功 2 失败
      flag: 0,
      loading: false, //是否已扫码
      msg: "", //登录状态返回
      dataToken1: [],
      dataToken:"",
      qrcodeType: {
        show: false,
      },
      //存储地址
      dizhi:"",
      sbk:{},
      getUuid: undefined,
      base64: undefined,
      noLogin: true,
      activeName: "first",
      form: {
        userType: "0",
        telephone: undefined,
        idCard: undefined,
        code: undefined,
      },
      switchForm: {
        telephone: undefined,
        password: undefined,
        repassword: undefined,
        code: undefined,
      },
      passwordForm: {
        userType: "0",
        userName: undefined,
        password: undefined,
      },
      rules: {
        userType: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      passwordRules: {
        userType: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      switchRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        repassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
        ],
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      isCanLogin: false,
      btnText1: "获取验证码",
      btnText2: "获取验证码",
      isCanGetCode1: false,
      isCanGetCode2: false,
      isFindPassword: false,
      showTips1: false,
      showTips2: false,
      userInfo: {},
      systemPremission:''
    };
  },
  mounted() {
    this.backUrl = window.location.href;
    console.log(this.backUrl,"9999999999999999999");
    // this.initQrCode();
    window.addEventListener("keyup", this.onSubmit, false);
    this.systemPremission = sessionStorage.getItem('systemPremission')
  },
  destroyed() {
    window.removeEventListener("keyup", this.onSubmit, false);
  },
  created() {
    // console.log(encodeURIComponent('http://mgk.zeda.com.cn/'))
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // console.log(this.$route.query,"333333333333333333333")
    //判断当前路由是否有datatoken这个参数
    // if (this.$route.query.dataToken !== "") {
    //   sbktoken(this.$route.query.dataToken).then(res1 => {
    //        console.log(JSON.parse(res1.data,"爸爸吧爸爸吧 "));

    //     })


    // } else {
    //   this.$message.warning("扫码未成功")
    // }
    if ('dataToken' in this.$route.query && this.$route.query.dataToken !== null) {
      sbktoken(this.$route.query.dataToken).then(res1 => {
        console.log(res1,"第一次网络请求");
        // console.log(JSON.parse(res1.data, "爸爸吧爸爸吧 "));
        const data = JSON.parse(res1.data)
        if (data.code == 0) {
          // this.ldGx005a = data.respContent.userCardNo
          const datas = {
            ldGx005a:data.respContent.userCardNo
          }
           sbklogins(datas).then(res2 => {
             console.log(res2, "第二次网络请求");
             if (res2.code == 200) {
               sessionStorage.setItem("userInfo", JSON.stringify(res2.data));
                  localStorage.setItem('AIuserInfo', JSON.stringify(res2.data))
               this.$message.success("登录成功");
                this.$router.push('/loginHome');
                  this.showEwm();

          }
           }).catch((res2) => {
            console.log(res2,"第二次网络请求");
           })

        } else {
          this.$message.warning("登录失败！！！")
        }
        })

    }


  },
  methods: {

    //跳转电子社保卡页面
    // sbklogin() {
    //   window.open(this.dizhi);
    // },
    //获取电子社保卡链接
    initQrCode() {
      if(this.systemPremission && this.systemPremission == 'NO'){
        return this.tipsConfirm()
      }
      console.log("111111111111")
      const data = {
        backUrl: this.backUrl,
        systemName: "河南省劳动关系权益劳动保障平台",
        channelNo:"9400000034"
      }
      getsbklogin(data).then(res => {
        // console.log(JSON.parse(res.data));
        this.sbk = JSON.parse(res.data);
        console.log(this.sbk, "999999999");
        console.log(this.sbk.respContent.qrcode_url)
        this.dizhi = this.sbk.respContent.qrcode_url;
        window.open(this.dizhi);
        this.dataToken1 =this. dizhi.split("=");
        this.dataToken = this.dataToken1[1]
        // console.log(this.dataToken, "88888888")

        // const times = setInterval(() => {
        //  sbktoken(this.dataToken).then(res1 => {
        //    console.log(JSON.parse(res1.data,"爸爸吧爸爸吧 "));

        // })

        // },2000)

      })


   },



    onSubmit(e) {
      if (e.keyCode == 13) {
        this.activeName == "first"
          ? this.login(1)
          : this.activeName == "second"
            ? this.login(2)
            : "";
      }
    },
    hideEvent() {
      this.qrcodeType.show = false;
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    clickCode() {
      if(this.systemPremission && this.systemPremission == 'NO'){
       return this.tipsConfirm()
      }
      // let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      getUuid()
        .then((res) => {
          this.getUuid = res.data.data;
          let url ="https://qybz.hrss.henan.gov.cn/wechat.html?state=" + this.getUuid;
          this.text = "微信扫码登陆";
          // return
          this.flag = 0;
          this.msg = "请使用微信扫描二维码进行登录";
          QRCode.toDataURL(url, {
            width: 150,
            height: 150,
            ref: "canvas",
          })
            .then((base64) => {
              this.base64 = base64;
              this.qrcodeType.show = true;
            })
            .catch((err) => {
              console.log(err);
            });
          this.timer = setInterval(() => {
            wechatLoginLog(this.getUuid)
              .then((res) => {
                if (res.code == 200) {
                  if (res.data.status == 0) {
                    this.flag = 2;
                    this.loading = false;
                    this.text = "登录失败，刷新重试！";
                    this.msg = res.data.msg;
                    clearInterval(this.timer);
                  } else if (res.data.status == 1) {
                    this.flag = 1;
                    this.text = "登录成功！";
                    this.loading = false;
                    this.msg = "正在登录，请稍后...";
                    clearInterval(this.timer);
                    sessionStorage.setItem(
                      "userInfo",
                      JSON.stringify(res.data.user)
                    );
                    localStorage.setItem('AIuserInfo', JSON.stringify(res.data.user))
                    setTimeout(() => {
                      if (this.$route.query.redirect) {
                        this.$router.push(this.$route.query.redirect);
                      } else {
                        this.$router.push('/loginHome');
                      }
                      this.showEwm();
                    }, 2000);
                  } else if (res.data.status == 2) {
                    // 已扫码
                    this.flag = 0;
                    this.loading = true;
                    this.msg = res.data.msg;
                  }
                }
              })
              .catch((err) => {
                console.log(err);
                clearInterval(this.timer);
              });
          }, 2000);
        })
        .catch(() => {
          console.log(2123);
        });
    },
    getTeleohoneCode() {
      if (!this.form.telephone) {
        this.$message.error("请输入手机号");
        return;
      }
      existenceOrNot(this.form.telephone)
        .then((response) => {
          console.log(response);
          if (response.code == 200 && response.data == true) {
            this.showTips2 = true;
            let count = 60;
            this.btnText2 = count + "s";
            this.isCanGetCode2 = true;
            getPhoneCode({mobile:this.form.telephone}).then((res) => {
              let timer = setInterval(() => {
                count--;
                this.btnText2 = count + "s";

                if (count == 0) {
                  this.btnText2 = "重新获取验证码";
                  this.isCanGetCode2 = false;
                  clearInterval(timer);
                }
              }, 1000);
              console.log(res);
            });
          } else if (response.data == false) {
            this.$message.error("当前手机还未注册！");
          }
        })
        .catch(() => {
          this.$message.error("登录失败，请重试！");
        });
    },
    tipsConfirm(){
      this.$confirm('当前地市暂未开通互联网服务，暂不支持此功能，具体请联系当地人社部门！', '提示', {
        confirmButtonText: '我已知晓',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{}).catch(()=>{})
    },
    goPage(val){
      if(this.systemPremission && this.systemPremission == 'NO'){
        return this.tipsConfirm()
      }
      if(val == 'register'){
        this.$router.push('/register')
      }else if(val == 'forget'){
        this.$router.push('/forgetPassword')
      }

},
    login(type) {
      if(this.systemPremission && this.systemPremission == 'NO'){
       return this.tipsConfirm()
      }
      if (type == 1) {
        this.$refs["passwordForm"].validate((valid) => {
          if (valid) {
            let loginForm = {
              userName: this.passwordForm.userName,
              password: this.passwordForm.password,
              userType: this.passwordForm.userType,
            };
            loginIn(loginForm)
              .then((res) => {
                console.log(res);
                if (res.code == 200) {
                  this.$message.success("登录成功");
                  sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                  localStorage.setItem('AIuserInfo', JSON.stringify(res.data))
                  if (this.$route.query.redirect) {
                    this.$router.push(this.$route.query.redirect);
                  } else {
                    if (this.passwordForm.userType == "0") {
                      this.$router.push("/loginHome");
                    } else {
                      this.$router.push("/loginHomeqy");
                    }
                  }
                  this.showEwm();
                }
              })
              .catch(() => {
                console.log(2123);
              });
          } else {
            return false;
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.userType == "0") {
            }
            let loginForm = {
              ldGx005a: this.form.idCard,
              ldGx007a: this.form.telephone,
              userType: this.form.userType,
              code: this.form.code,
            };
            loginIn(loginForm)
              .then((res) => {
                console.log(res);
                if (res.code == 200) {
                  this.$router.push('/loginHome');
                  this.showEwm();

                  this.$message.success("登录成功");
                  sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                  localStorage.setItem('AIuserInfo', JSON.stringify(res.data))

                  console.log(this.$router.query.redirect, "123123");
                }
              })
              .catch(() => {
                console.log(2123);
              });
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imgss{
   text-align: center;
   margin-top: 20px;
}
.sbks{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;

}
.container {
  background: #fff url(../../../assets/images/loginBg.jpg) no-repeat center top;
  background-size: 100% 100%;
  min-width: 1200px;
  height: 706px;
  padding-top: 26px;
  position: relative;
  background-size: 100%;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 100px;
    width: 100%;
    min-width: 1200px;
    background-color: rgba(255, 255, 255, 0.3) !important;
    // backdrop-filter: blur(4px);
    filter: blur(1px);
  }

  .flex {
    display: flex;
  }

  .wh1200 {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .noLogin {
      span {
        padding-right: 10px;
        color: white;
      }

      .toLogin,
      .toRegister {
        cursor: pointer;
      }
    }

    .wx-code-box {
      margin-right: 20px;

      a {
        color: #fff;
      }

      &:hover a {
        color: #fff;
      }
    }

    .wx-code {
      font-size: 14px;
      color: #909399;

      img {
        display: block;
        width: 140px;
        margin: 0 auto;
      }
    }
  }

  .someTips {
    position: absolute;
    white-space: normal;
    font-size: 60px;
    color: white;
    font-weight: bolder;
    top: 330px;
    left: 50px;
  }

  .loginBox {
    width: 300px;
    min-height: 400px;
    background-color: white;
    border-radius: 10px;
    position: absolute;
    top: 180px;
    right: 300px;
    padding: 20px;

    #scanCode {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 50px;
      z-index: 100;

      img {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
    }

    #qrcodeContainer {
      position: absolute;
      top: 0px;
      right: 0;
      width: 340px;
      min-height: 440px;
      z-index: 999;
      border-radius: 10px;
      background-color: #fff;

      // display: none;
      #qrcode {
        width: 340px;
        height: 340px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        img {
          display: inline-block;
          width: 80px;
          height: 80px;
        }
      }

      .qrcodeBtnTop {
        width: 310px;
        height: 50px;
        line-height: 40px;
        text-align: right;
        padding-right: 30px;
        cursor: pointer;
        color: #576b95;
      }

      .qrcodeBtn {
        width: 340px;
        height: 50px;
        line-height: 40px;
        text-align: center;
      }
    }

    .otherDo {
      display: flex;
      justify-content: space-between;
      margin-left: 20px;
      margin-top: -15px;
    }

    .otherDo2 {
      width: 200px;
      display: flex;
      justify-content: flex-end;
      margin-left: 50px;
      margin-top: 15px;
    }
  }
}

.bottom_bg {
  min-width: 1200px;
  background: #282828;
}
</style>
